module.exports = __webpack_public_path__ + "img/training-pic3.60d3b35f.png";